import Loading from "../../components/loading";

const Teste = () => {
	return (
		<div className="max-w-6xl">
			<div className="flex flex-col max-h-[160vh]">
				<div className="flex flex-col col-span-1 items-center justify-center">
					<span className="text-2xl font-bold text-gray-700 mt-1">Processando pagamento</span>
					<div className="">
						<Loading mensagem="Aguarde enquanto finalizamos seu pagamento..." />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Teste;
// import React, { useEffect, useRef, useState } from "react";
// import { FixedSizeGrid as Grid } from "react-window";
// import AutoSizer from "react-virtualized-auto-sizer";
// import "./style.css"; // Importe o arquivo CSS aqui
// import reqContaEntrada from "../../services/reqContaEntrada";
// import api from "../../services/api";
// import libFloat from "../../util/libFloat";

// const Teste = () => {
// 	const [contaEntradaData, setContaEntradaData] = useState([]);
// 	const [reachedEnd, setReachedEnd] = useState(false);
// 	const [loading, setLoading] = useState(false);
// 	const [columnCount, setColumnCount] = useState(2); // Começando com 3 colunas padrão
// 	const currentPage = useRef(1);

// 	useEffect(() => {
// 		fetchContaEntrada();
// 		window.addEventListener("resize", handleResize); // Adicionando event listener para redimensionamento da janela
// 		return () => {
// 			window.removeEventListener("resize", handleResize); // Removendo event listener ao desmontar o componente
// 		};
// 	}, []);

// 	const handleResize = () => {
// 		const screenWidth = window.innerWidth;
// 		let newColumnCount;
// 		if (screenWidth >= 1200) {
// 			newColumnCount = 3;
// 		} else if (screenWidth >= 800) {
// 			newColumnCount = 2;
// 		} else {
// 			newColumnCount = 1;
// 		}

// 		setColumnCount(newColumnCount);
// 	};

// 	const fetchContaEntrada = async () => {
// 		setLoading(true);
// 		const response = await reqContaEntrada.allContaEntrada(api, currentPage.current);
// 		setContaEntradaData((prevData) => [...prevData, ...response.data]);

// 		//se não encontrou nada esta na ultima pagina
// 		if (response.data.length === 0) {
// 			setReachedEnd(true);
// 		} else {
// 			currentPage.current++;
// 		}
// 		setLoading(false);
// 	};

// 	const handleClick = async (contaEntrada) => {};

// 	const Cell = ({ columnIndex, rowIndex, style }) => {
// 		const dataIndex = rowIndex * columnCount + columnIndex;
// 		const dataItem = contaEntradaData[dataIndex];

// 		return (
// 			<div style={style} className={`gridCell ${columnIndex % columnCount === 0 ? "evenColumn" : "oddColumn"}`}>
// 				{dataItem && (
// 					<div className="container-item" onClick={(e) => handleClick(dataItem)}>
// 						<div className="image">
// 							<img
// 								src="https://veja.abril.com.br/wp-content/uploads/2016/06/big-mac-original5-e1469131439850.jpeg?quality=90&strip=info"
// 								alt=""
// 							/>
// 						</div>
// 						<div className="description">
// 							<small className="d-block">
// 								<b>Nome do Produto</b>
// 							</small>
// 							<div className="description">
// 								<small className="d-block dimi">Descrição do produto</small>
// 							</div>

// 							<small className="d-inline-block mt-3">{dataItem.valor}</small>
// 						</div>
// 					</div>
// 				)}
// 			</div>
// 		);
// 	};

// 	const handleItemsRendered = ({ visibleRowStartIndex, visibleRowStopIndex }) => {
// 		const lastVisibleRowIndex = visibleRowStopIndex;
// 		const lastDataIndex = Math.floor(contaEntradaData.length / columnCount) - 1; // Último índice de dados

// 		if (lastVisibleRowIndex >= lastDataIndex && !loading) {
// 			fetchContaEntrada();
// 		}
// 	};

// 	return (
// 		<div className="container-fluid">
// 			<div className="teste-container col-lg-8 offset-lg-2 align-items-center justify-content-center">
// 				<div>
// 					<h1>teste</h1>
// 				</div>

// 				<AutoSizer>
// 					{({ height, width }) => (
// 						<Grid
// 							height={height}
// 							width={width}
// 							columnWidth={400}
// 							rowHeight={150}
// 							columnCount={columnCount}
// 							rowCount={Math.ceil(contaEntradaData.length / columnCount)}
// 							onItemsRendered={handleItemsRendered}
// 						>
// 							{Cell}
// 						</Grid>
// 					)}
// 				</AutoSizer>
// 			</div>
// 			{loading && <div>Carregando...</div>}
// 			{reachedEnd && <div>Chegou ao fim da lista.</div>}
// 		</div>
// 	);
// };

// export default Teste;

// import React, { useEffect, useRef, useState } from "react";
// import { FixedSizeList as List } from "react-window";
// import "./style.css"; // Importe o arquivo CSS aqui
// import reqContaEntrada from "../../services/reqContaEntrada";
// import api from "../../services/api";
// import libFloat from "../../util/libFloat";

// const Teste = () => {
// 	const [contaEntradaData, setContaEntradaData] = useState([]);
// 	const [reachedEnd, setReachedEnd] = useState(false); // Estado para controlar se a lista chegou ao fim
// 	const [loading, setLoading] = useState(false); // Estado para controlar o carregamento
// 	const currenPage = useRef(1);

// 	useEffect(() => {
// 		fetchContaEntrada();
// 	}, []);

// 	const fetchContaEntrada = async () => {
// 		setLoading(true); // Indicando que o carregamento está em andamento
// 		const response = await reqContaEntrada.allContaEntrada(api, currenPage.current);
// 		setContaEntradaData((prevData) => [...prevData, ...response.data]); // Concatenando novos dados à lista existente

// 		// Verificando se a resposta contém menos itens do que o esperado, indicando que chegamos ao fim
// 		if (response.data.length === 0) {
// 			setReachedEnd(true);
// 		} else {
// 			currenPage.current++;
// 		}

// 		setLoading(false); // Indicando que o carregamento terminou
// 	};

// 	const Row = ({ index, style }) => (
// 		<div style={style}>
// 			<div className="list">
// 				<span>{contaEntradaData[index].id_conta_entrada}</span>
// 				<span>{libFloat.strtoFloat(contaEntradaData[index].valor)}</span>
// 			</div>
// 		</div>
// 	);

// 	const handleItemsRendered = ({ visibleStopIndex }) => {
// 		if (visibleStopIndex >= contaEntradaData.length - 1 && !loading) {
// 			// Verificando se o último item visível está próximo do final da lista e se não está carregando
// 			fetchContaEntrada(); // Carregando mais itens
// 		}
// 	};

// 	return (
// 		<div className="teste-container">
// 			<div>
// 				<List
// 					height={200} // Altura do contêiner visível
// 					itemCount={contaEntradaData.length} // Número total de itens
// 					itemSize={50} // Altura de cada item
// 					width={600} // Largura do contêiner visível
// 					onItemsRendered={handleItemsRendered} // Monitorando quando os itens visíveis mudam
// 				>
// 					{Row}
// 				</List>
// 				{loading && <div>Carregando...</div>} {/* Indicador de carregamento */}
// 				{reachedEnd && <div>Chegou ao fim da lista.</div>}{" "}
// 				{/* Renderizando uma mensagem quando a lista chega ao fim */}
// 			</div>
// 		</div>
// 	);
// };

// export default Teste;
